<template>
    <div>
        <Header />
        <div class="banners">
            <Banner :src="src" />
        </div>
        <div class="union_container">
            <div v-html="text" class="union"></div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue';
import Banner from '../../components/Banner.vue';
import Footer from '../../components/Footer.vue';
import Axios from 'axios';
const Base64=require('js-base64');
export default {
    components:{
        Header,
        Banner,
        Footer,
    },
    data(){
        return{
            src:'',
            text:''
        }
    },
    mounted(){
         Axios({
				url:'/apiv2/sconfig/getlist',
				data: {},
				method: 'GET',
			}).then((res) => {
				for(var i=0;i<res.data.data.rows.length;i++){
					if(res.data.data.rows[i].sc_key.slice(0,8)=="UNIONPIC"){
						this.src=res.data.data.rows[i].sc_value
					}
                    if(res.data.data.rows[i].sc_key.slice(0,9)=="UNIONTEXT"){
						this.text=Base64.decode(res.data.data.rows[i].sc_value).replaceAll("<a","<a rel='noopener noreferrer'")
					}
				}
			})
    }
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px){
    @import '../../style/base.scss';
    .join_container{
        width: 1200px;
        margin: 0 auto;
        padding: 30px 0 80px;
       
    }
}
::v-deep .union_container{
    margin-top: 30px;
    margin-bottom: 30px;
    .union{
            width: 70%;
            margin: 0 auto;
            padding-top: 30px;
            text-align: left;
        }
}
::v-deep font{
    line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
</style>